var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-typo-default',
    ( _obj = {}, _obj[(_vm.cssPrefix + "--with-arrow")] = _vm.withArrow, _obj ) ].concat( _vm.customClasses )},[_c('sw-scroll-view',{style:(_vm.innerStyle),attrs:{"scrollbar-theme":"light"}},[_c('div',{class:[(_vm.cssPrefix + "__inner")]},[_vm._t("default")],2)]),_vm._v(" "),(_vm.withArrow)?_c('div',{class:[(_vm.cssPrefix + "__arrow")],attrs:{"x-arrow":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }